import { useState, useEffect, useCallback } from "react";
import {
  detectCurrency,
  formatPrice,
  parsePriceToNumber,
  updateCurrencyCache,
  SUPPORTED_CURRENCIES,
  CURRENCY_SYMBOLS,
} from "../lib/currencyService";

export function useCurrency() {
  const [currency, setCurrencyState] = useState("USD");
  const [rates, setRates] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    detectCurrency().then((result) => {
      if (cancelled) return;
      setCurrencyState(result.currency);
      setRates(result.rates);
      setIsLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const setCurrency = useCallback(
    (newCurrency) => {
      setCurrencyState(newCurrency);
      if (Object.keys(rates).length > 0) {
        updateCurrencyCache(newCurrency, rates);
      }
    },
    [rates],
  );

  const formatProductPrice = useCallback(
    (priceString) => {
      if (!rates || Object.keys(rates).length === 0) return priceString;
      return formatPrice(priceString, currency, rates);
    },
    [currency, rates],
  );

  const convertToNumber = useCallback(
    (priceString) => {
      const base = parsePriceToNumber(priceString);
      const rate = rates?.[currency] || 1;
      return base * rate;
    },
    [currency, rates],
  );

  return {
    currency,
    rates,
    isLoading,
    setCurrency,
    formatProductPrice,
    convertToNumber,
    supportedCurrencies: SUPPORTED_CURRENCIES,
    currencySymbols: CURRENCY_SYMBOLS,
  };
}
